export const SCROLL_EFFECTS = [
  {
    type: 'NONE',
    name: 'Scroll with the Page',
    section: 'menu'
  },
  {
    type: 'STICKY',
    name: 'Freezes on Top',
    section: 'menu'
  },
  {
    type: 'SLIDE',
    name: 'Slides Out/In',
    section: 'menu'
  },
  {
    type: 'FADE',
    name: 'Fades Out/In',
    section: 'menu'
  },
  {
    type: 'BACKGROUND_SLIDE',
    name: 'Slides Out/In',
    section: 'background'
  },
  {
    type: 'BACKGROUND_FADE',
    name: 'Fades Out/In',
    section: 'background'
  }
]